import React from 'react'
import med1 from '../Images/med (1).jpg'
import med2 from '../Images/med (2).jpg'
import med3 from '../Images/med (3).jpg'
import med from '../Images/med.jpeg'
import Image from 'react-bootstrap/Image';
import '../Cardpage.css'
function Gallerysection() {
  return (
    <>
       <div className='gallsec'>
            <div>
                <Image src={med3} thumbnail />
            </div>
            <div>
                <Image src={med2} thumbnail />
            </div>
            <div>
                <Image src={med1} thumbnail />
            </div>
            <div>
                <Image src={med} thumbnail />
            </div>
       </div>
    </>
  )
}

export default Gallerysection